import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

interface IPrivateRouteProps {}

const PrivateRoute: React.FC<IPrivateRouteProps> = () => {
  const { signed, loadingSession } = useAuth();

  if (loadingSession) {
    return <></>;
  }

  return signed ? <Outlet /> : <Navigate to="/p/cadastrar" />;
};

export default PrivateRoute;
